import { useState, useEffect } from "react";
import { X } from "lucide-react";
import SponsorLogo from "@/components/editorial/SponsorLogo";

const KEY_PREFIX = "mm-sponsor-badge-dismissed:";

/**
 * Floating "PRESENTADO POR" overlay with sponsor logo. Top-right of a video container.
 * Persists dismissal in localStorage per (storageKey).
 */
export default function SponsorVideoBadge({ sponsor, storageKey, tone = "light" }) {
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    if (!storageKey) return;
    const dismissed = localStorage.getItem(KEY_PREFIX + storageKey);
    setHidden(!!dismissed);
  }, [storageKey]);

  if (!sponsor || hidden) return null;

  const dismiss = () => {
    if (storageKey) localStorage.setItem(KEY_PREFIX + storageKey, "1");
    setHidden(true);
  };

  return (
    <div data-testid="sponsor-video-badge" className="absolute top-3 right-3 z-10 inline-flex items-center gap-3 bg-cream/90 backdrop-blur-md px-4 py-2 rounded-sm border border-charcoal/10 shadow-md max-w-[280px]">
      <p className="text-[9px] uppercase tracking-[0.24em] text-charcoal/60 leading-none whitespace-nowrap">Presentado por</p>
      <div className="shrink-0">
        <SponsorLogo sponsor={sponsor} tone={tone} size="sm" />
      </div>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Cerrar"
        className="shrink-0 h-5 w-5 inline-flex items-center justify-center text-charcoal/40 hover:text-charcoal"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
